<template>
    <b-modal ref="resend-email-modal" ok-only>
      <p>{{ modalMessage }}</p>
    </b-modal>
</template>

<script>
  export default {
    data() {
      return {
        modalType: ''
      }
    },
    computed: {
      resendActivationEmailMessage: function () {
        return this.$store.getters["players/resendActivationEmailMessage"]
      },
      resendPasswordResetEmailMessage: function () {
        return this.$store.getters["players/resendPasswordResetEmailMessage"]
      },
      modalMessage: function() {
        return this.modalType === 'activationEmail' ? this.$t(this.resendActivationEmailMessage) : this.$t(this.resendPasswordResetEmailMessage);
      }
    },
    methods: {
      showModal(modalType) {
        this.modalType = modalType;
        this.$refs['resend-email-modal'].show();
      },
      hideModal() {
        this.$refs['resend-email-modal'].hide();
      }
    }
  }
</script>
